import { render, staticRenderFns } from "./parentProgress.vue?vue&type=template&id=ed398878&scoped=true&"
import script from "./parentProgress.vue?vue&type=script&lang=js&"
export * from "./parentProgress.vue?vue&type=script&lang=js&"
import style0 from "./parentProgress.vue?vue&type=style&index=0&id=ed398878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed398878",
  null
  
)

export default component.exports